import { Suspense } from "react"
import { ProductListingSkeleton } from "../ProductListingSkeleton/ProductListingSkeleton"
import { MeilisearchProductsListing, ProductListing } from "@/components/sections"
import { TabsContent, TabsList } from "@/components/molecules"
import { SellerReviewTab } from "@/components/cells"
import { getTranslate } from "@/tolgee/server"

const ALGOLIA_ID = process.env.NEXT_PUBLIC_ALGOLIA_ID
const ALGOLIA_SEARCH_KEY = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY
const USE_LOCAL_SEARCH = !!process.env.NEXT_PUBLIC_USE_LOCAL_SEARCH
export const SellerTabs = async ({
  tab,
  seller_handle,
  seller_id,
  locale,
  currency_code,
  searchParams
}: {
  tab: string
  seller_handle: string
  seller_id: string
  locale: string
  currency_code?: string
  searchParams: any
}) => {
  const t = await getTranslate()
  const tabsList = [
    { value: "products", label: t('seller_tabs.products'), link: `/sellers/${seller_handle}/` },
    {
      value: "reviews",
      label: t('seller_tabs.reviews'),
      link: `/sellers/${seller_handle}/reviews`,
    },
  ]

  return (
    <div className="mt-8">
      <TabsList list={tabsList} activeTab={tab} />
      <TabsContent value="products" activeTab={tab}>
        <Suspense fallback={<ProductListingSkeleton />}>
          {USE_LOCAL_SEARCH ? <ProductListing showSidebar seller_id={seller_id} page={searchParams.page} seller_handle={seller_handle} locale={locale} /> : <MeilisearchProductsListing
            searchParams={searchParams}
            locale={locale}
            seller_handle={seller_handle}
            currency_code={currency_code}
          />}
        </Suspense>
      </TabsContent>
      <TabsContent value="reviews" activeTab={tab}>
        <Suspense>
          <SellerReviewTab seller_handle={seller_handle} />
        </Suspense>
      </TabsContent>
    </div>
  )
}
